import { ConfigService } from './config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { TransferenciaDistribuidoresCabecera } from '../models/transferenciaDistribuidoresCabecera';
import { TokenService } from '../utils/token.service';
import { environment } from 'src/environments/environment';
import { BuscadorTD } from '../models/buscadorTD';

@Injectable({
  providedIn: 'root'
})
export class TDService {

  private tdServerUri: string;
  private apiUrl = environment.apiUrl;

  constructor(
    private httpCliente: HttpClient,
    private configService: ConfigService,
    private tokenService: TokenService
  ) {
    this.tdServerUri = this.apiUrl + '/' + this.configService.TDURI;
  }

  private getHeaders() {
    const authToken = this.tokenService.getAuthToken();
    const authTokenBearer = this.tokenService.getAuthTokenBearer();

    return new HttpHeaders({
      'Authorization': `Bearer ${authTokenBearer}`,      
      'PortalO2G' : `${authToken}`
    });
  }

  aprobarTransferenciaDistribuidores(tdc: TransferenciaDistribuidoresCabecera) {
    return this.httpCliente.post(this.tdServerUri + 'AprobarTransferenciaDistribuidores', tdc, { headers: this.getHeaders() });
  }

  rechazarTransferenciaDistribuidores(tdc: TransferenciaDistribuidoresCabecera) {
    return this.httpCliente.post(this.tdServerUri + 'RechazarTransferenciaDistribuidores', tdc, { headers: this.getHeaders() });
  }
  cTransferenciasDistribuidores(buscador: BuscadorTD) {
    return this.httpCliente.post(this.tdServerUri + 'CTransferenciasDistribuidores', buscador, { headers: this.getHeaders() });
  }
  cTransferenciaDistribuidores(idPais: string, idCompania: string, idSalesOrg: string, idTipoOrden: string, codigo: number) {
    return this.httpCliente.get(this.tdServerUri + 'CTransferenciaDistribuidores?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idTipoOrden=" + idTipoOrden + "&codigo=" + codigo, { headers: this.getHeaders() });
  }
  amTransferenciaDistribuidores(tdc: TransferenciaDistribuidoresCabecera) {
    return this.httpCliente.post(this.tdServerUri + 'AMTransferenciaDistribuidores', tdc, { headers: this.getHeaders() });
  }
  aTransferenciaDistribuidoresItem(tdc: TransferenciaDistribuidoresCabecera) {
    return this.httpCliente.post(this.tdServerUri + 'ATransferenciaDistribuidoresItem', tdc, { headers: this.getHeaders() });
  }
  mTransferenciaDistribuidoresItem(tdc: TransferenciaDistribuidoresCabecera) {
    return this.httpCliente.post(this.tdServerUri + 'MTransferenciaDistribuidoresItem', tdc, { headers: this.getHeaders() });
  }
  bTransferenciaDistribuidoresItem(codigoCabecera: number, codigoItem: number) {
    return this.httpCliente.get(this.tdServerUri + 'BTransferenciaDistribuidoresItem?codigoCabecera=' + codigoCabecera + "&codigoItem=" + codigoItem, { headers: this.getHeaders() });
  }
  cListasPreciosAutocompleteSearch(idPais: string, idCompania: string, idSalesOrg: string, nroCliente: string, idFormaPago: string, idGrupoCliente: string, idTipoOrden: string, search: string) {
    return this.httpCliente.get(this.tdServerUri + 'CListasPreciosAutocompleteSearch?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&nroCLiente=" + nroCliente + "&idFormaPago=" + idFormaPago + "&idGrupoCliente=" + idGrupoCliente + "&idTipoOrden=" + idTipoOrden + "&search=" + search, { headers: this.getHeaders() });
  }
  cListaPrecioItemsAutocompleteSearch(idPais: string, idCompania: string, idSalesOrg: string, idTipoListaPrecios: string, idTerminoPago: string, idMoneda: string, search: string) {
    idMoneda = typeof idMoneda == 'undefined' || idMoneda == null ? "" : idMoneda
    idTerminoPago = typeof idTerminoPago == 'undefined' || idTerminoPago == null ? "" : idTerminoPago
    idTipoListaPrecios = typeof idTipoListaPrecios == 'undefined' || idTipoListaPrecios == null ? "" : idTipoListaPrecios
    return this.httpCliente.get(this.tdServerUri + 'CListaPrecioItemsAutocompleteSearch?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idTipoListaPrecios=" + idTipoListaPrecios + "&idTerminoPago=" + idTerminoPago + "&idMoneda=" + idMoneda + "&search=" + search, { headers: this.getHeaders() });

  }
  cTerminosPagoTipoListaPrecios(idPais: string, idCompania: string, idSalesOrg: string, idTipoListaPrecios: string) {
    return this.httpCliente.get(this.tdServerUri + 'CTerminosPagoTipoListaPrecios?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idTipoListaPrecios=" + idTipoListaPrecios, { headers: this.getHeaders() });
  }

  cDireccionesDistribuidorCliente(idPais: string, idCompania: string, idSalesOrg: string, nroCliente: string, nroClienteDistribuidor: string) {
    return this.httpCliente.get(this.tdServerUri + 'CDireccionesDistribuidorCliente?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&nroCliente=" + nroCliente + "&nroClienteDistribuidor=" + nroClienteDistribuidor, { headers: this.getHeaders() });
  }
  cListaPreciosDivisionCabecera(idPais: string, idCompania: string, idSalesOrg: string, idComprobante: string, idDivision: string) {
    return this.httpCliente.get(this.tdServerUri + 'CListaPreciosDivisionCabecera?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idComprobante=" + idComprobante + "&idDivision=" + idDivision, { headers: this.getHeaders() })
  }
  cTransferenciaDistribuidoresItem(codigoItem: number) {
    return this.httpCliente.get(this.tdServerUri + 'CTransferenciaDistribuidoresItem?codigoItem=' + codigoItem, { headers: this.getHeaders() });
  }
  cTransferenciasLotes(idPais: string, idCompania: string, idSalesOrg: string, idProducto: string, idSucursal) {
    return this.httpCliente.get(this.tdServerUri + 'CTransferenciasLotes?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idProducto=" + idProducto + "&nroClienteDireccion=" + idSucursal, { headers: this.getHeaders() });
  }
  cStoragesLocationsPlanta(idPais: string, idCompania: string, idSalesOrg: string) {
    return this.httpCliente.get(this.tdServerUri + 'CStoragesLocationsPlanta?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg, { headers: this.getHeaders() });
  }
}
